import type { Answers, Groups } from "../../../features/questionnaire";
import type { validators } from "../../Questionnaire/validation/question/rules";
import { applyRules, ok } from "../../Questionnaire/validation/question/rules";
import type { ValidationResponse } from "../../Questionnaire/validation/question/rules/types";
import type { PartialQuestion } from "../../Questionnaire/validation/form/types";
import type { Cover } from "../../PersonalisedCover/CoverOptions/types";
import {
  buildPercentagesAnswer,
  buildPercentagesAnswerForGroup,
} from "./utils";

export type ValidateQuestionParams = {
  question: PartialQuestion | Cover;
  answers: Answers;
  locale?: string;
  groups?: Groups;
};

export const inferredValidationList = ["tel", "email", "postcode", "zipcode"];

export const validateQuestion = ({
  question,
  answers,
  locale,
  groups,
}: ValidateQuestionParams): ValidationResponse => {
  const { name, validation, visible, display } = question;
  let inferredValidation = validation;

  // Infer validation for display type "tel" or "email"
  if (display?.type && inferredValidationList.includes(display?.type)) {
    inferredValidation = { type: display.type as keyof typeof validators };
  }

  if (!inferredValidation || !visible) {
    return ok(name);
  }

  let answer = (answers[name] ?? "").toString();

  if (question.validation?.type === "percentages") {
    answer =
      display?.type === "percentage_split_group" && groups
        ? buildPercentagesAnswerForGroup(name, groups, answers)
        : buildPercentagesAnswer(name, answers);
  }
  const result = applyRules({
    name,
    validation: inferredValidation,
    answer,
    locale,
    questionErrorMessage: question.errorMessage,
  });

  return result ?? ok(name);
};
